import { useEffect, useRef, useState } from 'react';
import WebUniversal, { WUExtendPropsType, initDataType } from '../../system/WebUniversalNewEx'
import { columnsheadId } from '../../universal/columnshead';
import dayjs from 'dayjs';
import { Button, Input, Modal, Select, Space, Tooltip } from 'antd';
import fetchApi from '../../../utils/api/fetchApi';
import getList from '../../../utilsTsx/universal/getList';
import antMessage from '../../../utils/extend/AntdNotification';

/** 组件 */
const WebComponent = (props: any) => {
    const apiId = 'webProductOrderPickupGoods';
    const ref = useRef<any>(undefined);

    /** 后端数据defaultService */
    const [defaultService, setDefaultService] = useState<string>('');
    const [initData, setInitData] = useState<any>();
    const [productStatusData, setProductStatusData] = useState<any>();
    const [selectProductStatus, setSelectProductStatus] = useState<any>(2);
    const [modalVisible, setModalVisible] = useState<boolean>(false);
    const [pickupCode, setPickupCode] = useState<string>();
    const [reasonForCancellation, setReasonForCancellation] = useState<string>('');
    const [modalData, setModalData] = useState<{
        /** 主题 */
        title: string,
        /** 是否提货 */
        isPickup: boolean,
        /** 产品订单详情id */
        productOrderDetailId?: string,
        /**　信息　 */
        info?: string
    }>({ title: '提货', isPickup: true });


    useEffect(() => {
        let dSerive = '';
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            dSerive = ref.current.defaultService;
            setInitData(() => ref.current.initData);
            setDefaultService(dSerive);
        }
        //同步获取数据 async - await
        const fetchData = async () => {
            fetchApi.GET(dSerive,
                {
                    apiId: 'generalData',
                    apiVariable: 'productStatus',
                    apiExtend: 'showList'
                }).then(res => {
                    if (res.success) {
                        setProductStatusData(res.data);
                    }
                })
        };
        fetchData();
    }, []); //初始化数据

    /**
     * 提货或取消
     * @param isPickup 
     * @param productOrderDetailId 
     */
    const pickupOrCancel = (isPickup: boolean,
        productOrderDetailId?: string,
        info?: string) => {
        setModalData({
            title: isPickup === true ? '提货' : '取消（不是退款，退款需要客人在小程序操作）',
            isPickup,
            productOrderDetailId,
            info
        })
        setPickupCode('');
        setReasonForCancellation('');
        setModalVisible(true);
    };

    /**
     * 执行
     * @param isPickup 
     * @param productOrderDetailId 
     */
    const excutePickupOrCancel = (isPickup: boolean, productOrderDetailId?: string
    ) => {
        if (isPickup === true) {
            fetchApi.PUT(defaultService,
                {
                    apiId: 'webProductOrderPickupGoods',
                    apiExtend: 'execute',
                    apiData: {
                        pickupCode
                    }
                }).then(res => {
                    if (res.success === true) {
                        antMessage('info', '已提货');
                        if (initData) {
                            initData();
                        }
                    } else {
                        antMessage('error', res.message);
                    }
                })
        } else {
            fetchApi.PUT(defaultService,
                {
                    apiId: 'webProductOrderPickupGoods',
                    apiExtend: 'cancellation',
                    apiData: {
                        productOrderDetailId,
                        reasonForCancellation
                    }
                }).then(res => {
                    if (res.success === true) {
                        antMessage('info', '已取消');
                        if (initData) {
                            initData();
                        }
                    } else {
                        antMessage('error', res.message);
                    }
                })
        }
    };

    /**
     * 表头内容
     */
    const columnsHead = [
        {
            title: '产品',
            dataIndex: 'productName'
        },
        {
            title: '规格',
            dataIndex: 'productPriceSpec',
        },
        {
            title: '数量',
            dataIndex: 'amount',
        },
        {
            title: '单位',
            dataIndex: 'productUnit',
        },
        {
            title: '购入时间',
            dataIndex: 'id',
            render: (val: any, record: any) =>
                <span>
                    {dayjs(record.sysDate.createdAt).format('YYYY-MM-DD HH:mm:ss')}
                </span>,
        },
        {
            title: '总价',
            dataIndex: 'totalPurchasePrice'
        },
        {
            title: '提货时间',
            dataIndex: 'receiveDate',
            render: (val: any, record: any) =>
                <span>
                    {dayjs(val).format('YYYY-MM-DD HH:mm:ss')}
                </span>,
        },
        {
            title: '提货码',
            dataIndex: 'pickupCode',
            render: (val: string) => <span style={{ color: 'red', fontSize: '16px' }}>{val}</span>
        },
        {
            title: '取消',
            dataIndex: 'id',
            render: (val: any, record: any) =>
                <span>{
                    record?.pickupCode ?
                        <Button onClick={() => pickupOrCancel(false, val,
                            `${record.productName} - ${record.productPriceSpec} - ` +
                            `数量：${record.amount}${record.productUnit}，总价：${record.totalPurchasePrice}`)}>取消</Button>
                        : null}
                </span>,
        },
    ];

    /** 表头 */
    const columns = columnsheadId
        .concat(columnsHead as []);

    /** 扩展Props */
    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '产品订单提货',
        apiId,
        columns,
        showStates: true,
        showOperation: false,
        showAdd: false,
        sendPageData: { productStatusId: selectProductStatus }
    };

    /** 查看不同产品状态的订单 */
    const orderStatusChange = (e: any) => {
        setSelectProductStatus(e);
        const currentData: initDataType = {
            apiId,
            sendPageData: { productStatusId: e }
        }
        ref.current.initData(currentData);
    };

    return (
        <><Space>
            <Select
                showSearch
                defaultValue="所有状态"
                onChange={orderStatusChange}
                placeholder="产品状态"
                optionFilterProp="children"
                value={selectProductStatus}
                filterOption={(input, option: any) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                {getList.general(productStatusData, { includeNull: true })}
            </Select>
            <Button type='primary' onClick={() => pickupOrCancel(true)}>提货</Button>
        </Space>
            <text>   </text>
            <WebUniversal props={extendProps} ref={ref} />
            {modalVisible === true ?
                <Modal
                    title={modalData.title}
                    open={modalVisible}
                    onOk={() => {
                        if (modalData.isPickup === false) {
                            if (reasonForCancellation === '') {
                                antMessage('error', '请输入取消原因');
                                return;
                            }
                        }
                        excutePickupOrCancel(modalData.isPickup, modalData.productOrderDetailId);
                        setModalVisible(false);
                    }}
                    onCancel={() => setModalVisible(false)}
                    cancelButtonProps={{ style: { display: "none" } }} >
                    {modalData.isPickup === true ? <Space>提货码：
                        <Tooltip placement="topLeft" title={'提货码通常由10位数字及字母组成'}>
                            <Input onChange={(e) => setPickupCode(e.currentTarget.value)
                            }></Input></Tooltip></Space> :
                        <Space>取消原因： <Tooltip placement="topLeft" title={'请输入取消原因'}>
                            <Input onChange={(e) => setReasonForCancellation(e.currentTarget.value)
                            }></Input></Tooltip></Space>}
                    <p></p>
                    <text>{modalData.productOrderDetailId ?
                        `id：${modalData.productOrderDetailId}`
                        : ''}</text>
                    <p>{modalData.info}</p>
                </Modal >
                : null}
        </>
    )
}

export default WebComponent;